/*** IMPORTS FROM imports-loader ***/
var define = false;

"use strict";

function getBytesRemaining(fileProgress) {
  return fileProgress.bytesTotal - fileProgress.bytesUploaded;
}

module.exports = getBytesRemaining;
